import { useNavigate } from 'react-router-dom';
import NavBar from '../../components/feature/NavBar';
import TabBar from '../../components/feature/TabBar';
import Card from '../../components/base/Card';

export default function Games() {
  const navigate = useNavigate();
  
  const games = [
    {
      id: 'snakes-ladders',
      title: 'Phonics Snakes & Ladders',
      description: 'Practice decodable words on every square',
      difficulty: 'Easy',
      players: '2-4 Players',
      duration: '15-20 min',
      image: 'https://readdy.ai/api/search-image?query=3D%20cartoon%20board%20game%20snakes%20and%20ladders%2C%20colorful%20game%20board%20with%20numbered%20squares%2C%20wooden%20dice%2C%20game%20pieces%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look&width=400&height=300&seq=snakes1&orientation=landscape'
    },
    {
      id: 'word-puzzle',
      title: 'Word Puzzle',
      description: 'Find words and expand vocabulary',
      difficulty: 'Medium',
      players: '1-2 Players',
      duration: '10-15 min',
      image: 'https://readdy.ai/api/search-image?query=3D%20cartoon%20word%20puzzle%20game%2C%20colorful%20letter%20tiles%20scattered%20on%20a%20game%20board%2C%20alphabet%20blocks%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look&width=400&height=300&seq=word1&orientation=landscape'
    },
    {
      id: 'spelling-race',
      title: 'Spelling Race',
      description: 'Speed up your spelling skills',
      difficulty: 'Hard',
      players: '2-6 Players',
      duration: '8-12 min',
      image: 'https://readdy.ai/api/search-image?query=3D%20cartoon%20spelling%20racing%20game%2C%20colorful%20racing%20track%20with%20letters%20and%20words%2C%20alphabet%20blocks%20and%20pencils%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look&width=400&height=300&seq=spell1&orientation=landscape'
    }
  ];
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50">
      <NavBar />
      <TabBar />
      
      <div className="pt-20 md:pt-24 pb-20 md:pb-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Literacy Games</h2>
            <p className="text-lg md:text-xl text-gray-600">Choose a game to practice reading and spelling skills!</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {games.map((game) => (
              <Card 
                key={game.id}
                hover
                onClick={() => navigate(`/game/${game.id}`)}
                className="overflow-hidden h-full cursor-pointer"
              >
                <div className="aspect-video rounded-xl overflow-hidden bg-gray-100 mb-4">
                  <img 
                    src={game.image}
                    alt={game.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{game.title}</h3>
                  <p className="text-gray-600 mb-4">{game.description}</p>
                  
                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      game.difficulty === 'Easy' ? 'bg-green-100 text-green-700' :
                      game.difficulty === 'Medium' ? 'bg-yellow-100 text-yellow-700' :
                      'bg-red-100 text-red-700'
                    }`}>
                      {game.difficulty}
                    </span>
                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-700">
                      {game.players}
                    </span>
                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-[#2d5a35]/10 text-[#2d5a35]">
                      {game.duration}
                    </span>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-[#2d5a35] font-medium">Play Now</span>
                    <i className="ri-arrow-right-line text-[#2d5a35]"></i>
                  </div>
                </div>
              </Card>
            ))}
          </div>
          
          <div className="mt-12 md:mt-16">
            <Card className="text-center max-w-md mx-auto">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2d5a35] to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-add-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">More Games Coming Soon</h3>
              <p className="text-gray-600 mb-4">We're adding new literacy games regularly to help you learn</p>
              <img 
                src="https://static.readdy.ai/image/1624bf5855e87197e9f976fe97d0b1c6/4a99c4ae32eb70e334047e2a84452586.png" 
                alt="Sprout mascot" 
                className="w-12 h-12 mx-auto opacity-60"
              />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
